export const REGULATOR_PORTAL_PATH_PREFIX = "/regulator-portal";

export const REGULATOR_PORTAL_DASHBOARD_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/dashboard`;

export const REGULATOR_PORTAL_SIGN_IN_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/sign-in`;

export const REGULATOR_PORTAL_SET_PASSWORD_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/set-password`;

export const REGULATOR_PORTAL_RESULTS_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/results`;

export const REGULATOR_PORTAL_RESULT_DETAIL_ROUTE = `${REGULATOR_PORTAL_RESULTS_ROUTE}/:resultId`;

export const REGULATOR_PORTAL_RULES_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/rules`;

export const REGULATOR_PORTAL_RULE_DETAIL_ROUTE = `${REGULATOR_PORTAL_RULES_ROUTE}/:ruleId`;

export const REGULATOR_PORTAL_SERVICES_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/services`;

export const REGULATOR_PORTAL_REPORTS_ROUTE = `${REGULATOR_PORTAL_PATH_PREFIX}/reports`;

export const REGULATOR_PORTAL_REPORT_DETAIL_ROUTE = `${REGULATOR_PORTAL_REPORTS_ROUTE}/:runId`;

export const isRegulatorPortalPath = (pathname: string): boolean =>
  pathname.startsWith(REGULATOR_PORTAL_PATH_PREFIX);

const encodePathSegment = (value: string): string =>
  encodeURIComponent(value.trim());

export const buildRegulatorPortalResultPath = (
  resultId?: string | null,
): string => {
  const id = resultId?.trim();
  if (!id) return REGULATOR_PORTAL_RESULTS_ROUTE;
  return `${REGULATOR_PORTAL_RESULTS_ROUTE}/${encodePathSegment(id)}`;
};

export const buildRegulatorPortalRulePath = (
  ruleId?: string | null,
): string => {
  const id = ruleId?.trim();
  if (!id) return REGULATOR_PORTAL_RULES_ROUTE;
  return `${REGULATOR_PORTAL_RULES_ROUTE}/${encodePathSegment(id)}`;
};

export const decodeRegulatorPortalPathId = (value: string): string => {
  try {
    return decodeURIComponent(value).trim();
  } catch {
    return value.trim();
  }
};

export const buildRegulatorPortalReportPath = (
  runId?: string | null,
): string => {
  const id = runId?.trim();
  if (!id) return REGULATOR_PORTAL_REPORTS_ROUTE;
  return `${REGULATOR_PORTAL_REPORTS_ROUTE}/${encodePathSegment(id)}`;
};
